import React, { useState, useEffect } from 'react';
import { Modal, Input } from 'antd';
import Editor from 'react-simple-wysiwyg';
import { useSelector } from 'react-redux';
import { selectTheme } from '../../redux/features/appSlice';

const { TextArea } = Input;

const RichTextEditor = ({ value, onChange, placeholder, modalTitle = "Rich Text Editor" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editorContent, setEditorContent] = useState(value || '');
  const { isDarkMode } = useSelector(selectTheme);

  // Update editor content when value prop changes
  useEffect(() => {
    setEditorContent(value || '');
  }, [value]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    onChange(editorContent);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    // Reset to original value if canceled
    setEditorContent(value || '');
    setIsModalOpen(false);
  };

  const handleEditorChange = (e) => {
    setEditorContent(e.target.value);
  };

  // Function to safely render HTML content
  const createMarkup = (html) => {
    return { __html: html || placeholder || "Click to edit content..." };
  };

  return (
    <div className="rich-text-editor-wrapper">
      <div 
        className="html-preview"
        onClick={showModal}
        style={{ 
          border: '1px solid #d9d9d9',
          borderRadius: '2px',
          padding: '4px 11px',
          minHeight: '80px',
          cursor: 'pointer',
          backgroundColor: isDarkMode ? '#1f1f1f' : '#fff',
          color: isDarkMode ? '#fff' : 'rgba(0, 0, 0, 0.88)',
          transition: 'all 0.3s',
          position: 'relative',
          overflow: 'auto',
          maxHeight: '200px'
        }}
      >
        {value ? (
          <div dangerouslySetInnerHTML={createMarkup(value)} />
        ) : (
          <div style={{ color: 'rgba(0, 0, 0, 0.45)', padding: '5px 0' }}>
            {placeholder || "Click to edit in Rich Text Editor..."}
          </div>
        )}
      </div>

      <Modal
        title={modalTitle}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="90%"
        centered
        bodyStyle={{ 
          maxHeight: '70vh', 
          overflow: 'auto',
          backgroundColor: isDarkMode ? '#1f1f1f' : '#fff'
        }}
        okText="Save"
        cancelText="Cancel"
        className={isDarkMode ? 'dark-mode-modal' : ''}
      >
        <Editor 
          value={editorContent} 
          onChange={handleEditorChange}
          style={{ 
            minHeight: '300px',
            backgroundColor: isDarkMode ? '#2d2d2d' : '#fff',
            color: isDarkMode ? '#fff' : '#000'
          }}
        />
      </Modal>
    </div>
  );
};

export default RichTextEditor;
